export function isNumber(o: unknown): o is number {
	return typeof o === 'number';
}

export function isActualNumber(o: unknown): o is number {
	return isNumber(o) && !isNaN(o);
}

export function isBoolean(o: unknown): o is boolean {
	return typeof o === 'boolean';
}

export function isObject<T = Record<string, unknown>>(o: unknown, keys?: (keyof T)[]): o is T {
	if (typeof o !== 'object' || o === null) {
		return false;
	}

	if (!keys) {
		return true;
	}

	return keys.every((k) => k in (o as object));
}

export function isString(o: unknown): o is string {
	return typeof o === 'string';
}

export function isArray<T = unknown>(o: unknown): o is T[] {
	return Array.isArray(o);
}

export function isArrayOfArrays<T = unknown>(o: unknown): o is T[][] {
	return isArray(o) && o.every(isArray);
}

export function isStringAndNotNullOrEmpty(o: unknown): o is string {
	return Boolean(o) && isString(o) && o.length > 0;
}

export type FunctionType = (...args: unknown[]) => unknown;
export function isFunction<T extends FunctionType = FunctionType>(o: unknown): o is T {
	return typeof o === 'function';
}

export function isNullOrUndefined(o: unknown): o is null | undefined {
	return o === null || o === undefined;
}

export function isDate(o: unknown): o is Date {
	if (o instanceof Date) {
		return !isNaN(o.getTime());
	}
	if (isString(o)) {
		const parsedDate = new Date(o);
		return !isNaN(parsedDate.getTime());
	}
	return false;
}

export type StringOrNumber = string | number;

export function isStringOrNumber(o: unknown): o is StringOrNumber {
	return isString(o) || isNumber(o);
}

export function isStringNumber(value: string) {
	return value !== '' && Number.isFinite(Number(value));
}
